// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-container[data-v-586cc278]{height:100vh;padding:0 15px;font-size:14px;line-height:22px;overflow:auto;text-align:left}.page-container .h2[data-v-586cc278]{margin:10px 0;font-size:16px}[data-v-586cc278] .van-nav-bar__content{display:block;line-height:46px;background-color:#fff}[data-v-586cc278] .van-nav-bar .van-icon{font-size:18px;color:#111!important}[data-v-586cc278] .van-nav-bar__title{color:#000}", ""]);
// Exports
module.exports = exports;
